import { configureStore as toolkitConfigureStore } from "@reduxjs/toolkit";
import rootReducer from "../reducers";

/** The only caller (`ProviderApp`) passes `undefined`; RTK treats it as "no preloaded state". */
export default function configureStore(preloadedState: undefined) {
  return toolkitConfigureStore({
    reducer: rootReducer,
    preloadedState,
    devTools: true,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // breadCrumbData items may carry render/handler functions (BreadCrumbItem.template) — e.g. the
          // FileExplorer folder breadcrumbs whose crumbs render a clickable node that navigates the tree.
          ignoredPaths: ["fileUploadList", "currentFileUploadProperties", "fileUploadProperties", "breadCrumbData"],
          ignoredActions: [
            "fileUploadList/setFileUploadData",
            "fileUploadList/updateFileUploadData",
            "breadCrumbData/setBreadCrumbData",
          ],
        },
      }),
  });
}
